import { render, staticRenderFns } from "./courseSearch.vue?vue&type=template&id=0854b8b4&scoped=true"
import script from "./courseSearch.vue?vue&type=script&lang=js"
export * from "./courseSearch.vue?vue&type=script&lang=js"
import style0 from "./courseSearch.vue?vue&type=style&index=0&id=0854b8b4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0854b8b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0854b8b4')) {
      api.createRecord('0854b8b4', component.options)
    } else {
      api.reload('0854b8b4', component.options)
    }
    module.hot.accept("./courseSearch.vue?vue&type=template&id=0854b8b4&scoped=true", function () {
      api.rerender('0854b8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/homePage/courseSearch.vue"
export default component.exports